// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip_tooltip__lOLnl {
  pointer-events: none;

  z-index: 11;

  flex: none;

  padding: 6px 12px;
  border-radius: 2px;

  font-size: 12px;
  font-weight: 700;
  font-style: normal;
  line-height: 15px;
  color: var(--textColor);
  white-space: nowrap;

  background: var(--backgroundColor);
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
}
.tooltip_tooltip__lOLnl[data-status='open'],.tooltip_tooltip__lOLnl[data-status='close'] {
    transition-duration: 0.2s;
    transition-property: opacity, margin;
  }
.tooltip_tooltip__lOLnl[data-status='initial'],.tooltip_tooltip__lOLnl[data-status='close'] {
    opacity: 0;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='top'],.tooltip_tooltip__lOLnl[data-status='close'][data-placement^='top'] {
    margin-top: 34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='bottom'],.tooltip_tooltip__lOLnl[data-status='close'][data-placement^='bottom'] {
    margin-top: -34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='left'],.tooltip_tooltip__lOLnl[data-status='close'][data-placement^='left'] {
    margin-left: 34px;
  }
.tooltip_tooltip__lOLnl[data-status='initial'][data-placement^='right'],.tooltip_tooltip__lOLnl[data-status='close'][data-placement^='right'] {
    margin-left: -34px;
  }
@media (prefers-contrast: more) {
    .tooltip_tooltip__lOLnl {
      border: 1px solid var(--borderColor);
    }
  }
@media (forced-colors: active) {
    .tooltip_tooltip__lOLnl {
      border: 1px solid ButtonBorder;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;;EAEpB,WAAW;;EAEX,UAAU;;EAEV,iBAAiB;EACjB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;;EAEnB,kCAAkC;EAClC,+CAA+C;AAuCjD;AArCE;IAEE,yBAAyB;IACzB,oCAAoC;EACtC;AACA;IAEE,UAAU;EACZ;AACA;IAEE,gBAAgB;EAClB;AACA;IAEE,iBAAiB;EACnB;AACA;IAEE,iBAAiB;EACnB;AACA;IAEE,kBAAkB;EACpB;AAEA;IACE;MACE,oCAAoC;IACtC;EACF;AAEA;IACE;MACE,8BAA8B;IAChC;EACF","sourcesContent":[".tooltip {\n  pointer-events: none;\n\n  z-index: 11;\n\n  flex: none;\n\n  padding: 6px 12px;\n  border-radius: 2px;\n\n  font-size: 12px;\n  font-weight: 700;\n  font-style: normal;\n  line-height: 15px;\n  color: var(--textColor);\n  white-space: nowrap;\n\n  background: var(--backgroundColor);\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n  &[data-status='open'],\n  &[data-status='close'] {\n    transition-duration: 0.2s;\n    transition-property: opacity, margin;\n  }\n  &[data-status='initial'],\n  &[data-status='close'] {\n    opacity: 0;\n  }\n  &[data-status='initial'][data-placement^='top'],\n  &[data-status='close'][data-placement^='top'] {\n    margin-top: 34px;\n  }\n  &[data-status='initial'][data-placement^='bottom'],\n  &[data-status='close'][data-placement^='bottom'] {\n    margin-top: -34px;\n  }\n  &[data-status='initial'][data-placement^='left'],\n  &[data-status='close'][data-placement^='left'] {\n    margin-left: 34px;\n  }\n  &[data-status='initial'][data-placement^='right'],\n  &[data-status='close'][data-placement^='right'] {\n    margin-left: -34px;\n  }\n\n  @media (prefers-contrast: more) {\n    & {\n      border: 1px solid var(--borderColor);\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      border: 1px solid ButtonBorder;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip_tooltip__lOLnl`
};
module.exports = ___CSS_LOADER_EXPORT___;
